import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'customTimeDuration',
  pure: false
})
export class CustomTimeDurationPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

transform(value: number, unit: string = 'minute'): string {
  if (isNaN(value) || value < 0) return '';

  const unitToMinutesMap: Record<string, number> = {
    minute: 1,
    minutes: 1,
    hour: 60,
    hours: 60,
    day: 480,      // 8 hours
    days: 480,
    week: 2400,    // 5 days
    weeks: 2400,
    month: 9600,   // 20 working days
    months: 9600,
    year: 115200,  // 12 months
    years: 115200
  };

  const unitKey = unit?.toLowerCase();
  const multiplier = unitToMinutesMap[unitKey] || 1;
  let totalMinutes = value * multiplier;

    if (totalMinutes <= 0) {
      return '-';
    }
    const units = [
      { key: 'year', minutes: 115200 },
      { key: 'month', minutes: 9600 },
      { key: 'week', minutes: 2400 },
      { key: 'day', minutes: 480 },
      { key: 'hour', minutes: 60 },
      { key: 'minute', minutes: 1 }
    ];

    const primaryUnit = units.find(u => totalMinutes >= u.minutes);
    if (!primaryUnit) {
      // Just return 0 minutes
      return this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.duration.minutes', { count: 0 });
    }

    const primaryValue = Math.floor(totalMinutes / primaryUnit.minutes);
    const remainingMinutes = totalMinutes % primaryUnit.minutes;

    const secondaryUnit = units.find(u => u.minutes < primaryUnit.minutes);
    let secondValueDecimal = 0;

    if (secondaryUnit) {
      secondValueDecimal = +(remainingMinutes / secondaryUnit.minutes).toFixed(2);
    }

    const parts: string[] = [];

    const primaryLabel = this.translate.instant(
      `ORDERMANAGEMENT.MANAGEORDERS.duration.${primaryValue > 1 ? primaryUnit.key + 's' : primaryUnit.key}`
    );
    parts.push(`${primaryValue} ${primaryLabel}`);

    if (secondValueDecimal > 0) {
      const secondLabel = this.translate.instant(
        `ORDERMANAGEMENT.MANAGEORDERS.duration.${secondValueDecimal > 1 ? secondaryUnit.key + 's' : secondaryUnit.key}`
      );
      parts.push(`${secondValueDecimal} ${secondLabel}`);
    }

  const conjunction = this.translate.instant('ORDERMANAGEMENT.MANAGEORDERS.duration.and');
  return parts.join(` ${conjunction} `);
}
}
